import type { OperationFilters } from './types';

/**
 * Clearing a filter must DELETE its key, never set it to `undefined`.
 * The dialog gates the bulk operation on `Object.keys(filters).length > 0`, so a
 * lingering key makes an unfiltered run look filtered — and the backend then has
 * the account id as its only predicate, i.e. every subscription on the tenant.
 */
export function withFilter<K extends keyof OperationFilters>(
  filters: OperationFilters,
  key: K,
  value: OperationFilters[K] | undefined,
): OperationFilters {
  const next = { ...filters };
  if (value === undefined || (Array.isArray(value) && value.length === 0)) {
    delete next[key];
  } else {
    next[key] = value;
  }
  return next;
}
